import { InvoiceListOutlineIcon } from './InvoiceListOutlineIcon';

/**
 * author: Jeff Anders
 * id 9674415D-706E-4934-A03F-9AE29B24E3A9
 * name invoice-list-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-list-outline.svg
 * tags
 * - Shopping 
 * - Banking 
 */
export const InvoiceLineItemsOutlineIcon = InvoiceListOutlineIcon;
export default InvoiceLineItemsOutlineIcon